import type { PFCAdminContext } from '../../data/wpApi'

const FLASHCARDS_NAMESPACE = '/perlingo-flashcards/v1'
const COURSES_NAMESPACE = '/perlingo-courses/v1'

/**
 * Accepts any REST base the editor may be given (WordPress root, flashcards or courses
 * namespace, or a deeper flashcards URL) and returns the flashcards namespace URL.
 */
export function normalizeFlashcardsRestUrl(value: string) {
  const base = String(value || '').replace(/\/+$/, '')
  if (!base) return ''
  if (base.endsWith(FLASHCARDS_NAMESPACE)) return base

  const flashcardsIndex = base.indexOf(`${FLASHCARDS_NAMESPACE}/`)
  if (flashcardsIndex >= 0) return base.slice(0, flashcardsIndex + FLASHCARDS_NAMESPACE.length)

  if (base.endsWith(COURSES_NAMESPACE)) {
    return `${base.slice(0, -COURSES_NAMESPACE.length)}${FLASHCARDS_NAMESPACE}`
  }
  return `${base}${FLASHCARDS_NAMESPACE}`
}

const deckBase = (ctx: PFCAdminContext) =>
  `${normalizeFlashcardsRestUrl(ctx.restUrl)}/decks/${encodeURIComponent(String(ctx.postId))}`

export const deckUrl = deckBase
export const flowGraphUrl = (ctx: PFCAdminContext) => `${deckBase(ctx)}/flow-graph`
export const playerResetUrl = (ctx: PFCAdminContext) => `${deckBase(ctx)}/player/reset`

/** wp-admin list of decks, where the standalone editor returns after save/cancel. */
export function decksListUrl(ctx: PFCAdminContext) {
  const postType = typeof ctx.postType === 'string' && ctx.postType ? ctx.postType : 'pfc_deck'
  return new URL(
    `edit.php?post_type=${encodeURIComponent(postType)}`,
    window.location.href,
  ).toString()
}
